import { createActions } from 'redux-actions';

export const actions = createActions(
  'ATTACHMENTS_PREVIEW_MODAL_OPEN',
  'ATTACHMENTS_PREVIEW_MODAL_CLOSE',
  'ATTACHMENTS_PREVIEW_MODAL_NEXT',
  'ATTACHMENTS_PREVIEW_MODAL_PREVIOUS',
);
